import DataTable from 'datatables.net-bs5';
import 'datatables.net-buttons-bs5';
import 'datatables.net-rowgroup-bs5';
import 'datatables.net-rowreorder-bs5';
import 'datatables.net-select-bs5';
import 'datatables.net-responsive-bs5';
import DefaultRenderers from './Renderers/DefaultRenderers.js';
import DefaultPlugins from './Plugins/DefaultPlugins.js';
import NL from './languages/nl.js';
import AlertClass from "@wielink/datatables/Alert";

const Alert = new AlertClass();

class Table {
	filters = {}

	constructor(config) {
		this.config = Object.assign({
			scope: '',
			language: NL,
			renderers: DefaultRenderers,
			plugins: DefaultPlugins,
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length < 1) {
			return;
		}

		this.init();
	}

	init() {
		this._initializeDatatable();
	}

	_initializeDatatable() {
		this.$scope.each((index, element) => {
			let $table = $(element);
			let config = this._merge({
				dom: '<"top"<"clear"><"clear">>rt<"bottom"i<"clear">pl<"clear">>',
				initComplete: this._initComplete.bind(this, $table),
				language: this.config.language,
				lengthMenu: [[10, 25, 50, 250], [10, 25, 50, 250]],
				buttons: this.defineButtons($table)
			}, $table.data('config'));

			config.ajax.data = this._ajaxData.bind(this, $table);
			this._renderColumns($table, config);
            this._bootPlugins($table, config);
			let datatable = $table.dataTable(config);
			this._initializePlugins($table, datatable, config);

			this.after(datatable);
		});
	}

	_renderColumns($table, config) {
		$.each(config.columns, (index, column) => {
			if (!column.render) {
				return;
			}

			let Renderer = this.config.renderers[column.render];

			if (column.render == 'selectCheckbox') {
				column.render = DataTable.render.select();
			} else {
				if (!Renderer) {
					throw 'Er is geen renderer met de naam ' + column.render;
				}

				column.render = (data, type, row, meta) => {
					return (new Renderer(data, type, row, meta, config)).render();
				};
			}

		});
	}

	_initComplete($table, settings, json) {

	}

	_ajaxData($table, data) {
		data.filters = this.filters;
	}

    _bootPlugins($table, config) {
        if (this.config.plugins.length < 1) {
            return;
        }

        for (let index in this.config.plugins) {
            let Plugin = this.config.plugins[index];

			// Dit is gedaan om een rare bug op te lossen.
			// Op het moment dat jij vanaf een andere pagina terug gaat naar een overzicht
			// doormiddel van het terug knopje van je browser, dan staan de plugins al als geinitaliseerd.
			if(typeof Plugin == 'function') {
				this.config.plugins[index] = (new Plugin($table, config, this));
			} else {
				this.config.plugins[index] = (new Plugin.constructor($table, config, this));
			}

            this.config.plugins[index].boot();
        }
    }
    _initializePlugins($table, datatable, config) {
        if (this.config.plugins.length < 1) {
            return;
        }
        for (let index in this.config.plugins) {
            this.config.plugins[index].setDatatable(datatable)
            this.config.plugins[index].init()
        }
    }
    

	reloadTable(datatable) {
		datatable.ajax.reload(null, false)
	}

	after(datatable) {
		this.$scope.on('click', '[data-dt-btn="delete"]', this.singleDelete.bind(this));
	}

	defineButtons($table) {
		let buttons = {
			dom: {
				button: {
					className: ''
				}
			},
			buttons: []
		}

		for (let button of this.buttonsBeforeDelete()) {
			buttons.buttons.push(button);
		}

		if (!$table.data('config')['hideDeleteButton']) {
			buttons.buttons.push({
				text: 'Verwijderen',
				className: 'btn btn-danger',
				action: this.bulkDelete.bind(this)
			});
		}

		return buttons;
	}

	buttonsBeforeDelete() {
		return [];
	}

	async singleDelete(event) {
		event.preventDefault();

		if (!await Alert.confirm('Weet u het zeker?')) {
			return;
		}

		let $target = $(event.currentTarget);
		if ($target.is('tr')) {
			$target = $target.find('[data-dt-btn="delete"]')
		}

		let $table = $target.closest('.dataTable');
		this.delete($table.DataTable(), [$target.data('id')]);
	}

	async bulkDelete(event, datatable, node, config) {
		if (!await Alert.confirm('Weet u het zeker?')) {
			return;
		}
		let ids = datatable.rows({selected: true}).data().toArray().map((row) => row.id);

		if (ids.length < 1) {
			Alert.alert('Selecteer minimaal één rij.')
			return;
		}

		datatable.rows({selected: true}).deselect();
		this.delete(datatable, ids);
	}

	delete(datatable, ids) {
		let controllerUrl = $(datatable.table().body()).closest('table').data('config')['deleteUrl'];
		$.ajax({
			url: controllerUrl,
			method: 'DELETE',
			data: {
				_method: 'DELETE',
				ids: ids
			},
			success: () => {
				datatable.ajax.reload();
			},
			error: (response) => {
				Alert.alert(response.responseJSON.message);
				datatable.ajax.reload();
			}
		});
	}

	_merge(target, ...sources) {
		for (let source of sources) {
			mergeValue(target, source)
		}

		return target

		function innerMerge(target, source) {
			for (let [key, value] of Object.entries(source)) {
				target[key] = mergeValue(target[key], value)
			}
		}

		function mergeValue(targetValue, value) {
			if (Array.isArray(value)) {
				if (!Array.isArray(targetValue)) {
					return [...value]
				} else {
					for (let i = 0, l = value.length; i < l; i++) {
						targetValue[i] = mergeValue(targetValue[i], value[i])
					}
					return targetValue
				}
			} else if (typeof value === "object") {
				if (targetValue && typeof targetValue === "object") {
					innerMerge(targetValue, value)
					return targetValue
				} else {
					return value ? {...value} : value
				}
			} else {
				return value ?? targetValue ?? undefined
			}
		}
	}
}

export default Table;
